import { DatePicker, DatePickerInput } from 'carbon-components-react'
import './index.scss'

DatePicker.Input = DatePickerInput
DatePicker.defaultProps = {
  allowInput: false
}
export { DatePicker, DatePickerInput, DatePicker as default }
